module.exports = __webpack_public_path__ + "assets/images/project/icon/age_icon.svg?v=bd3d0217";